import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as Misc from './../../misc';

import template from './FilterGroupValuesList.rt';

export class FilterGroupValuesList extends Component {
  static propTypes = {
    filterItems: PropTypes.array.isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    containerClass: PropTypes.string // class name for the outer container, it is different in different places
  }

  constructor(props) {
    super(props);

    this.state = {
      checkedItems: this.props.checkedItems || [],
      containerClass: this.props.containerClass || 'stone-filter-col-1'
    }
  }

  toggleItem = (e, item) => {
    Misc.ignoreDefault(e);
    if (!_.size(item.items || item.values)) {
      item.checked = !(this.isChecked(item));
    } else {
      item.expanded = !item.expanded;
    }
    let checked = [...this.state.checkedItems];
    if(item.checked) {
      checked.push(item.id);
    } else {
      _.remove(checked, c => c === item.id);
    }
    this.setState({checkedItems: checked}, () => {
      if(!_.size(item.items || item.values)) {
        this.props.handleFilterClick(item, this.props.type);
      }
    });
  }

  isChecked = (item) => {
    return item.checked || _.findIndex(this.state.checkedItems, c => c === item.id) >= 0;
  }

  render = template;
}
